import { CustomButton, SearchBar, SwitchButton } from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import "./PaymentManagement.scss";
import useDebounce from "common/UseDebounce";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import useButtonLoader from "common/UseButtonLoader";
import { searchDateFormat } from "common/InputForm";
import { toast } from "sonner";
import Pagination from "react-js-pagination";
import { DatePicker } from "common/InputForm";

import useFullPageLoader from "common/UseFullPageLoader";
import { dateFormat } from "utils/dateFormat";

import { paymentListApi } from "services/payment";
const PaymentManagement = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [paymentList, setPaymentList] = useState([]);
  const [search, setSearch] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");

  const [total, setTotal] = useState(null);

  const activePage = +searchParams.get("page") || 1;
  let searchStartDate = searchParams.get("startDate") || "";
  let searchEndDate = searchParams.get("endDate") || "";
  const limit = +searchParams.get("limit") || 10;
  const statusValue = searchParams.get("status") || "";


  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };

  // //*********start Date search********* */
  const handleStartDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("startDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("endDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    searchParams.delete("page");
    searchParams.delete("startDate");
    searchParams.delete("endDate");
    searchParams.delete("plan");
    searchParams.delete("bodyShape");
    searchParams.delete("styleIdentity");

    setSearch("");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };

  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };

  // user list handler
  const paymentHandler = async (
    page = activePage,
    limit = "10",
    search = debouncedValue,
    sortField = fieldName || "createdAt",
    sortDirection = direaction,
    startDate = searchStartDate,
    endDate = searchEndDate,
    status = statusValue,

  ) => {
    try {
      onShow();
      const res = await paymentListApi({
        page,
        search,
        limit,
        sortField,
        sortDirection,
        startDate,
        endDate,
        status,

      });
      if (res?.data?.status === 200) {
        setTotal(res?.data?.data?.total);
        setPaymentList(res.data?.data?.payments);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "userList");
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    paymentHandler();
  }, [
    searchParams,
    debouncedValue,
    fieldName,
    direaction,
    searchStartDate,
    searchEndDate,
    statusValue,

  ]);
  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);

  return (
    <>
      <div className="student_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3> Payment Management</h3>
            <div className="d-flex">
            </div>
          </div>
          <div className="button_section_wrap">
            <div className="search_wrapper">
              <SearchBar
                placeholder={"Search..."}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchParams.delete("page");
                  setSearchParams(searchParams);
                }}
                value={search}
              />
              <div className="d-flex">
                <select
                  className="input form-control"
                  value={statusValue}
                  onChange={handleStatus}
                >
                  <option value={""}>Select Status</option>
                  <option value="completed">Completed</option>
                  <option value="failed">Failed</option>
                </select>
                <DatePicker
                  className="form-control "
                  name="startDate"
                  selected={searchStartDate}
                  placeholder="Start Date"
                  onChange={(date) => handleStartDate(date)}
                  maxDate={searchEndDate}
                />
                <DatePicker
                  name="endDate"
                  className="form-control"
                  placeholder="End Date"
                  selected={searchEndDate}
                  onChange={(date) => handleEndDate(date)}
                  minDate={searchStartDate}
                />
                <CustomButton onClick={resetFilterHandler}>Reset</CustomButton>
              </div>
            </div>

          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap">S.No.</th>

                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("userInfo.name")}
                    >User Name
                      <span className="shorting">
                        {fieldName === "userInfo.name"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("amount")}
                    >
                      Amount
                      <span className="shorting">
                        {fieldName === "amount"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap cursor-pointer"
                      onClick={() => handleSort("createdAt")}
                    >
                      Payment Date
                      <span className="shorting">
                        {fieldName === "createdAt"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("paymentId")}
                    >
                      Payment Id
                      <span className="shorting">
                        {fieldName === "paymentId"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap cursor-pointer">Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {paymentList && paymentList?.length > 0 ? (
                    paymentList?.map((data, index) => {
                      return (
                        <tr key={++index}>
                          <td className="nowrap">{++index + (activePage - 1) * 10}</td>
                          <td className="nowrap">{data?.userInfo?.name}</td>
                          <td className="nowrap">{data?.amount ? `₹${data?.amount}` : "N/A"}</td>
                          <td className="nowrap">{dateFormat(data?.createdAt)}</td>
                          <td className="nowrap">{data?.paymentId}</td>
                          <td className="nowrap">{data?.status}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={12}
                      msg={"Payment data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>

            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>


    </>
  );
};

export default PaymentManagement;
